import React from "react";
import "./FinalCTASection.css";

const FinalCTASection = () => {
  return (
    <section className="final-cta-section">
      <div className="final-cta-overlay"></div>

      <div className="final-cta-content">
        <p className="final-cta-tagline">Your Growth Partner 🚀</p>
        <h2 className="final-cta-heading">
          <i>Let’s Build, Learn & Grow Together with</i>{" "}
          <span>MBR Network’s</span>
        </h2>
        <p className="final-cta-subtext">
          Whether you’re starting your career or growing your business,{" "}
          <b>MBR Network’s</b> is your partner in every step. Reach out today —
          let’s create something remarkable together.
        </p>

        <div className="final-cta-buttons">
          <button className="final-btn-primary">Get Started</button>
          <button className="final-btn-secondary">Join Our Network</button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
